/**
 * Una foto. Se descubre de abajo hacia arriba al entrar en pantalla.
 * `foto` viene siempre de src/data/fotos.js
 *
 * El recorte vive en la capa interior (.figura__velo) y no en la <figure>:
 * un clip-path sobre el propio elemento observado lo deja con area cero
 * para IntersectionObserver y no se revelaria nunca.
 */
export default function Figura({ foto, className = '', prioridad = false, retraso = 0 }) {
  return (
    <figure
      className={['figura', className].filter(Boolean).join(' ')}
      data-orientacion={foto.orientacion}
      data-reveal=""
      style={retraso ? { '--retraso': `${retraso}ms` } : undefined}
    >
      <div className="figura__velo">
        <img
          src={foto.src}
          alt={foto.alt}
          draggable="false"
          loading={prioridad ? 'eager' : 'lazy'}
          decoding="async"
        />
      </div>
    </figure>
  );
}
